import InfoWindow from 'components/Windows/InfoWindow/InfoWindow'
import { useIntl } from 'react-intl'

export default function ReservationInfo({ display }) {
    const intl = useIntl()
    if (display) {
        return (
            <InfoWindow
                color="blue"
                description={intl.formatMessage({ id: 'windows.notification.cantReserveWithMeal' })}
            />
        )
    }
}
